module.exports = __webpack_public_path__ + "media/images/nav_social/nav_youtube3-36bb2e3eb41efabc23376a629b0a3df2.svg";